class TypesHolidays {
    constructor(
        id,
        name,
    ) {
        this.id = id;
        this.name = name;
    }

    static fromJson({
        tipoFerId,
        tipoFerNombre
    }) {
        return new TypesHolidays(
            tipoFerId,
            tipoFerNombre

        );
    }
}

export default TypesHolidays;
